export default __webpack_public_path__ + "static/media/prev-MDS-1.082277b9.png";